import React from 'react';

import autoBind from 'react-autobind';
import { If, Then } from 'react-if'

// import other components within the same project here

import Localization from "composer/Localization.jsx"
import ProfileDialog from "composer/views/ProfileDialog.jsx"
import ChangePasswordDialog from "composer/views/ChangePasswordDialog.jsx"
import ReportBugDialog from "composer/views/ReportBugDialog.jsx"
import RootPage from "composer/pages/RootPage.jsx"
import AdminTaskDialog from "composer/views/AdminTaskDialog.jsx"

import { Icon, Button, IconButton, Tooltip, Menu, MenuItem, Switch, AppBar, Toolbar, Typography } from '@material-ui/core';
import { withTheme } from '@material-ui/core/styles';

const styles = {
  grow: {
    flexGrow: 1
  },
}

class TopBar extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      anchorEl: null,
      isLanguageMenuOpen: false,
      isAccountMenuOpen: false,
      isAdminMenuOpen: false,
      isSettingMenuOpen: false,
      isDarkModeEnabled: false,
    };
    autoBind(this);
    
  }

  componentDidMount = () => {
    const userdata = localStorage.getItem('userdata');
    console.log(userdata)
    const parsed_userdata = JSON.parse(userdata)
    const userinfo = JSON.parse(parsed_userdata.text)
    console.log(userinfo['user_info']['display_name'])
    const current_displayName = userinfo['user_info']['display_name'];
    if (current_displayName.startsWith('s-')){
      this.props.root.addNotification("Please change default display name", false);
      this.profileClicked()
    }
  }

  handleMenuClose = () => {
    this.setState({
      anchorEl: null,
      isLanguageMenuOpen: false,
      isAccountMenuOpen: false,
      isAdminMenuOpen: false,
      isSettingMenuOpen: false,
    });

    this.state.isLanguageMenuOpen = false;
    this.state.isAccountMenuOpen = false;
    this.state.isAdminMenuOpen = false;
    this.state.isSettingMenuOpen = false;
  };

  handleLanguageMenuOpen = event => {
    this.setState({ isLanguageMenuOpen: true });
    this.state.isLanguageMenuOpen = true;

    this.setState({ anchorEl: event.currentTarget });
    this.state.anchorEl = event.currentTarget;
  }

  handleAccountMenuOpen = event => {
    this.setState({ isAccountMenuOpen: true });
    this.state.isAccountMenuOpen = true;

    this.setState({ anchorEl: event.currentTarget });
    this.state.anchorEl = event.currentTarget;
  }

  adminTaskClicked() {
    this.refs.adminTaskDialog.setState({ open: true });
    this.refs.adminTaskDialog.state.open = true;
  }

  handleSettingMenuOpen = event => {
    this.setState({ isSettingMenuOpen: true });
    this.state.isSettingMenuOpen = true;

    this.setState({ anchorEl: event.currentTarget });
    this.state.anchorEl = event.currentTarget;
  }

  languageClicked(language) {
    Localization.strings.setLanguage(language);

    this.handleMenuClose();
    this.props.root.languageChanged();
  }

  profileClicked() {
    this.refs.profileDialog.setState({open: true});
    this.handleMenuClose();
  }

  changePasswordClicked() {
    this.refs.changePasswordDialog.setState({open: true});
    this.handleMenuClose();
  }

  logoutClicked() {
    this.props.root.refs.API.request("do_logout");
    this.props.root.changeStatus(this.props.root.STATUS_REQUIRE_LOGIN());
    localStorage.removeItem('userdata');

    this.props.root.replaceHistory("/");
  }

  handleDarkModeChanged(event) {
    this.setState({ isDarkModeEnabled: event.target.checked });
    this.state.isDarkModeEnabled = event.target.checked;
  }

  switchBackToClassicCLicked() {
    // window.open("//ev-cuhk.net", "_self");



  }

  reportBugClicked() {
// DEBUG CODE
    console.log("============");
    // console.log(this.props.root);
    // console.log(this.props.root.refs);
    // console.log(this.props.root.refs.LocaleViewerPage);
    // console.log(this.props.root.refs.LocaleViewerPage.getFilterString());
// DEBUG CODE ENDS

    this.refs.reportBugDialog.setState({open: true});
    this.handleMenuClose();
  }

  render() {
      return (
        <div ref="div">
          <AppBar
            position="static"
            style={{ backgroundColor: this.props.theme.palette.primary.main, boxShadow: 'none'}}
          >
            <Toolbar>
              <Typography variant="h5" style={{color:'White'}}>
                <If condition={this.props.root.state.status!=this.props.root.STATUS_VIEW_HOTSPOT()}>
                  <Then>
                    {this.props.root.state.status_titles[this.props.root.state.status]}
                  </Then>
                </If>

                <If condition={this.props.root.state.status==this.props.root.STATUS_VIEW_HOTSPOT()}>
                  <Then>
                    <If condition={this.props.root.refs.hotspotViewerPage != undefined && this.props.root.refs.hotspotViewerPage.state.currentView == 0}>
                      <Then>
                          {Localization.strings.HOTSPOT_LIST}

                      </Then>
                    </If>

                    <If condition={this.props.root.refs.hotspotViewerPage != undefined && this.props.root.refs.hotspotViewerPage.state.currentView == 1}>
                      <Then>
                          {Localization.strings.HOTSPOT_EDIT}

                      </Then>
                    </If>

                  </Then>
                </If>



              </Typography>
              <div style={styles.grow} />
                {/* <Button style={{color:"White"}} onClick={this.switchBackToClassicCLicked}>
                  {Localization.strings.SWITCH_BACK_TO_CLASSIC_UI}
                </Button> */}
                <Tooltip title={Localization.strings.LANGUAGE} placement="bottom-end">
                  <IconButton
                    style={{color:"White"}}
                    variant="fab"
                    aria-haspopup="true"
                    onClick={this.handleLanguageMenuOpen}
                  >
                    <Icon>language</Icon>
                  </IconButton>
                </Tooltip>
                <Menu
                  disableAutoFocusItem={true}
                  anchorEl={this.state.anchorEl}
                  transformOrigin={{ vertical: "top", horizontal: "center" }}
                  open={this.state.isLanguageMenuOpen}
                  onClose={this.handleMenuClose}
                >
                  <MenuItem onClick={() => this.languageClicked("en")}>English (Beta)</MenuItem>
                  <MenuItem onClick={() => this.languageClicked("tc")}>繁體中文</MenuItem>
                </Menu>
              <Tooltip title={Localization.strings.ACCOUNT_SETTINGS} placement="bottom-end">
                <IconButton
                  style={{color:"White"}}
                  variant="fab"
                  aria-haspopup="true"
                  onClick={this.handleAccountMenuOpen}
                >
                  <Icon>account_circle</Icon>
                </IconButton>
              </Tooltip>
              <Menu
                disableAutoFocusItem={true}
                anchorEl={this.state.anchorEl}
                transformOrigin={{ vertical: "top", horizontal: "center" }}
                open={this.state.isAccountMenuOpen}
                onClose={this.handleMenuClose}
              >
                <MenuItem onClick={this.profileClicked}>{Localization.strings.PROFILE}</MenuItem>
                <MenuItem onClick={this.changePasswordClicked}>{Localization.strings.CHANGE_PASSWORD}</MenuItem>
                <MenuItem onClick={this.logoutClicked}>{Localization.strings.LOGOUT}</MenuItem>
              </Menu>
              <If condition={this.props.root.refs.userDataProfile.state.userInfo.role == 2}>
                <Then>
                  <Tooltip title={Localization.strings.ADMIN_TASK} placement="bottom-end">
                    <IconButton
                      style={{color:"White"}}
                      variant="fab"
                      aria-haspopup="true"
                      onClick={this.adminTaskClicked}
                    >
                      <Icon>lock_outline</Icon>
                    </IconButton>
                  </Tooltip>
                </Then>
              </If>
              <Tooltip title={Localization.strings.SETTINGS} placement="bottom-end">
                <IconButton
                  style={{color:"White"}}
                  variant="fab"
                  aria-haspopup="true"
                  onClick={this.handleSettingMenuOpen}
                >
                  <Icon>settings</Icon>
                </IconButton>
              </Tooltip>
              <Menu
                disableAutoFocusItem={true}
                anchorEl={this.state.anchorEl}
                transformOrigin={{ vertical: "top", horizontal: "center" }}
                open={this.state.isSettingMenuOpen}
                onClose={this.handleMenuClose}
              >
                <MenuItem disabled={true}>
                  {Localization.strings.DARK_MODE}
                  <Switch
                    checked={this.state.isDarkModeEnabled}
                    color="primary"
                    onChange={this.handleDarkModeChanged}
                  />
                </MenuItem>
                <MenuItem onClick={this.switchBackToClassicCLicked}>{Localization.strings.SWITCH_BACK_TO_CLASSIC_UI}</MenuItem>
                <MenuItem onClick={this.reportBugClicked}>{Localization.strings.REPORT_BUG}</MenuItem>
              </Menu>
              <Tooltip title={Localization.strings.LOGOUT} placement="bottom-end">
                <IconButton
                  style={{color:"White"}}
                  variant="fab"
                  onClick={this.logoutClicked}
                >
                  <Icon>exit_to_app</Icon>
                </IconButton>
              </Tooltip>
            </Toolbar>
          </AppBar>

          <ProfileDialog parent={this} root={this.props.root} ref="profileDialog"/>
          <ChangePasswordDialog parent={this} root={this.props.root} ref="changePasswordDialog"/>
          <ReportBugDialog parent={this} root={this.props.root} ref="reportBugDialog"/>
          <AdminTaskDialog parent={this} root={this.props.root} ref="adminTaskDialog"/>

        </div>
      )
  }
}

export default withTheme(TopBar);
